import { render, staticRenderFns } from "./RouterViewWithErrorAndLoader.vue?vue&type=template&id=3cd85314&"
import script from "./RouterViewWithErrorAndLoader.vue?vue&type=script&lang=js&"
export * from "./RouterViewWithErrorAndLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports